import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Modal, Typography, Row, Col } from 'antd';
import ReactQuill from 'react-quill';
import ComponentMedia from '../containers/ComponentMediaContainer';
import Logger from '../../../../../lib/Logger';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const { Title } = Typography;

const modules = {
  toolbar: '#toolbar-read-only-module',
};

const LearningAdminModuleModalPreview = ({
  moduleId,
  load,
  learningModule,
  hideDetail,
  isVisible,
  partnershipId,
  trackerActions,
  ...props
}) => {
  // load record data from API
  useEffect(() => {
    if (partnershipId && moduleId) {
      load(partnershipId, moduleId);
    }
  }, [partnershipId, moduleId, load]);

  const onClickCancel = () => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_CLOSE_PREVIEW_MODULE
    );
    hideDetail();
  };

  if (learningModule === null) {
    return null;
  }

  return (
    <Translation>
      {(t) => (
        <>
          <Modal
            zIndex={3}
            title={
              <Title level={3} className='learning-admin-module-preview-title'>
                {learningModule?.title}
              </Title>
            }
            centered
            className='learning-admin-module-preview'
            visible={isVisible}
            onCancel={onClickCancel}
            footer={null}
            width={1400}
            bodyStyle={{ paddingTop: 0 }}
            forceRender={true}
          >
            <div className='learning-admin-module-preview-content'>
              <Row gutter={80}>
                <Col
                  lg={{ span: 12, order: 1 }}
                  md={{ span: 24, order: 1 }}
                  sm={{ span: 24, order: 1 }}
                  xs={{ span: 24, order: 1 }}
                  style={{ marginBottom: '40px' }}
                >
                  <div>
                    {learningModule && <ComponentMedia data={learningModule} />}
                  </div>
                </Col>
                <Col
                  lg={{ span: 12, order: 2 }}
                  md={{ span: 24, order: 2 }}
                  sm={{ span: 24, order: 2 }}
                  xs={{ span: 24, order: 2 }}
                >
                  <>
                    <Title level={4} style={{ marginBottom: '20px' }}>
                      {learningModule?.title}
                    </Title>

                    {learningModule?.content && (
                      <div className='learning-admin-module-content'>
                        <div id='toolbar-read-only-module'></div>
                        <ReactQuill
                          modules={modules}
                          readOnly
                          value={learningModule?.content}
                        />
                      </div>
                    )}
                  </>
                </Col>
              </Row>
            </div>
          </Modal>
        </>
      )}
    </Translation>
  );
};

export default LearningAdminModuleModalPreview;

Logger.log('silly', `LearningAdminModuleModalPreview loaded.`);
